import React, {useState, useRef, useEffect  } from 'react';
import { useLocation, useNavigate} from 'react-router-dom';
import DatePicker from 'react-datepicker';
import InputList from './InputList';
import RecruitInputs from './RecruitInputs';
import './Recruit.css';
import Text from '../common/Text.js'
import axios from 'axios';
import { format, setDate } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';

    // InputList 고윳값 // 숫자를 알파벳으로 변환 
const numberToAlphabet = (num) => {
    let result = '';
    while (num >= 0) {
        const remainder = num % 26;
        result = String.fromCharCode(97 + remainder) + result; // 'a'부터 시작
        num = Math.floor(num / 26) - 1; // 다음 26진수 자리 계산
    }
    return result;
};


const Recruit = () => {
    const [contents, setContents] = useState({
        title:"",
        dept: "",
        area: ""       
    })
    const [isOn, setIsOn] = useState(false); //모집상태 토글버튼
    const [statVal, setStatVal] = useState('active'); //모집상태 값
    const [expVal, setExpVal] = useState(''); //경력구분 콤보박스
    const [dateVal, setDateVal] = useState(null); //공고날짜!!!
    const createDt = format(new Date(), 'yyyy.MM.dd'); //저장날짜
    const [uploadId, setuploadId] = useState(''); //업로드할 파일

    //input placeHolders
    const [isDateInputClicked, setIsDateInputClicked] = useState(false); //모집일 input placeHolder
    const [isDeptInputClicked, setIsDeptInputClicked] = useState(false); //모집부서 input placeHolder

    //seq 값 받아와서 수정
    const navigate = useNavigate();
    const location = useLocation();
    var cardkey = location.state?.cardkey;
    var mode = location.state?.mode;

    //저장기능 관련
    const [detailItem, SetDetailItem] = useState([]);
    const [maxSeq, SetMaxSeq] = useState(0);
    const [inputCnt, setInputCnt] = useState(1);
    const [paramArrays, setParamArrays] = useState([]);
    const [currentNotice, setcurrentNotice] = useState([]);

    //수정모드일 때 값을 input 컴포넌트로 넘겨줄 때 사용한다.
    const [job, setJob] = useState([]); //채용직무
    const [perNo, setPerNo] = useState(''); //채용인원
    const [type, setType] = useState([]); //채용유형
    const [task, setTask] = useState([]); //담당업무
    const [reqShort, setReqShort] = useState([]); //지원자격 간단히
    const [reqLong, setReqLong] = useState([]); //지원자격 간단히
    const [prefShort, setPrefShort] = useState([]); //지원자격 간단히
    const [prefLong, setPrefLong] = useState([]); //지원자격 간단히

    //파일수정을 위해 DB에서 가져온다.
    const [files, setFiles] = useState([]);

    //useEffect 무한렌더링으로 인해 수정이 안 될 때 사용
    const refStatus = useRef('');
    const refExp = useRef('');
    const refTitle = useRef('');
    const refDate = useRef('');
    const refDept = useRef('');
    const refArea = useRef('');
    const refJob = useRef([]);
    const refPerNo = useRef([]);
    const refType = useRef('');
    const refTask = useRef('');
    const refReqShort = useRef('');
    const refReqLong = useRef('');
    const refPrefShort = useRef('');
    const refPrefLong = useRef('');

    // 각 InputList에 고윳값을 부여한다. 삭제할 때 찾아가기 위함  --2025 09 10
    const [inputIdList, setInputIdList] = useState([{ id: numberToAlphabet(0)}]);
    const nextNumId = useRef(1);

    //렌더링 시점인지를 판단하여 inputList의 갯수를 관리한다. 
    const [isLendering, setIsLendering] = useState(true);
    useEffect(()=>{
        getDetailData();
        getMaxSeq();}, []);

    useEffect(() => { 
        setDefaultData();
        getFile();
    },[currentNotice])

    useEffect(() => { 
        setDefaultData();
        getFile();
        
    },[files, uploadId]) 

     function getDetailData() {
         axios.get('/api/RecruitDetailSelect',{params:{id:cardkey}})
        .then(response => {
            const detailData = response.data;
            const filteredNotice = detailData.filter(notice => notice.MatchType === 'Current');
            const fileId = filteredNotice[0].Uploadid;
            setuploadId(fileId);
            setcurrentNotice(filteredNotice);
        })
        .catch(error => console.error("DB 가져오기 오류", error));
    }

    const getMaxSeq = () => {
        axios.get('/api/RecruitMaxSeq')
        .then(response => {SetMaxSeq(response.data);})
        .catch(error => console.error("DB 가져오기 오류", error));
    }

    const getFile = () => {
        const param = uploadId;
        if(param !== undefined && param !== null) {
            axios.get('/api/FileListSelect', { params: { uploadkey: param } })
            .then(response => {
                const file = response.data.map(fileInfo => ({
                    name: fileInfo.FileNm,
                    uploadId: fileInfo.UploadID,
                    fileId: fileInfo.Fileid,
                }));
            setFiles(file);  //수정모드에서 파일업로드 바인딩
            })
        }
    }

    const delNotice = (value) => {
        axios.delete('/api/RecruitJobDelete',{params:{seq:cardkey, childSeq: value}})
        .then(alert("삭제되었습니다."))
        .catch(error => console.error("DB 가져오기 오류", error));


    }

    //수정모드
    const setDefaultData = () => {
        //수정클릭한 공고
        const childSeqArray = currentNotice.map((child) => child.ChildSeq);

        // //수정모드에서는 값을 불러와서 넣는다
        if(mode === 'edit' && currentNotice && currentNotice.length > 0 ) {
            setInputCnt(currentNotice.length);
            currentNotice.map((items) => {
                
                // //모집상태
                if(items?.Status !== refStatus.current) {
                    if (items?.Status === 'active') {
                        setIsOn(true);
                        setStatVal('active');

                    } else if (items?.Status === 'closed') {
                        setIsOn(false);
                        setStatVal('closed');
                    }
                    refStatus.current = items?.Status;

                }

                //경력구분
                if(items?.Experience !== refExp.current) {
                    if(items.Experience === '경력·신입')
                    {
                        setExpVal('01');
                    }
                    else if(items.Experience === '경력') {
                        setExpVal('02');
                    }
                    else if(items.Experience === '신입') {
                        setExpVal('03');
                    }
                    refExp.current =  items?.Experience;
                }

                //공고제목
                if(items?.Noti_title !== refTitle.current || 
                    items?.Dept !== refDept.current ||
                    items?.Area !== refArea.current) {
                        setContents({
                            title: items.Noti_title,
                            dept: items.Dept,
                            area: items.Area
                    })
                    refTitle.current = items.Noti_title;
                    refDept.current = items.Dept; 
                    refArea.current = items?.Area;
                }

                //모집일
                if(items?.Noti_dt !== refDate.current) {
                    setDateVal(items?.Noti_dt);
                    refDate.current =  items?.Noti_dt;
                }
                
                //채용직무
                if(childSeqArray !== refJob.current) {
                    setJob(currentNotice.map((child) => child.ChildSeq));
                    refJob.current = currentNotice.map((child) => child.ChildSeq)
                }

                //채용인원
                if(items?.PerNum !== refPerNo.current) {
                    setPerNo(currentNotice.map((child) => child.PerNum));
                    refPerNo.current = currentNotice.map((child) => child.PerNum);
                }

                //채용유형
                if(items?.Employtype !== refType.current) {
                    setType(currentNotice.map((child) => child.Employtype));
                    refType.current =  currentNotice.map((child) => child.Employtype);
                }

                //담당업무
                if(items?.Job !== refTask.current) {
                    setTask(currentNotice.map((child) => child.Job));
                    refTask.current = currentNotice.map((child) => child.Job);
                }

                //지원자격 간단히
                if(items?.Required !== refReqShort.current) {
                    setReqShort(currentNotice.map((child) => child.Required));
                    refReqShort.current = currentNotice.map((child) => child.Required);
                }

                //지원자격 자세히
                if(items?.Required_Detail !== refReqLong.current) {
                    setReqLong(currentNotice.map((child) => child.Required_Detail));
                    refReqLong.current = currentNotice.map((child) => child.Required_Detail);
                }

                //우대조건 간단히
                if(items?.Preferred !== refPrefShort.current) {
                    setPrefShort(currentNotice.map((child) => child.Preferred));
                    refPrefShort.current = currentNotice.map((child) => child.Preferred);
                }

                //우대조건 자세히
                if(items?.Preferred_Detail !== refPrefLong.current) {
                    setPrefLong(currentNotice.map((child) => child.Preferred_Detail));
                    refPrefLong.current = currentNotice.map((child) => child.Preferred_Detail);
                }
            })
            
        } 
        

    }


    //토글버튼 값 변경 이벤트
    const toggle = () => {
        //bool로 받아서 string으로 넘긴다.
        setIsOn(prevState => !prevState);
        if(!isOn)
        {
            setStatVal('active');
        }
        else if (isOn)
        {
            setStatVal('closed');
        }
    };

    //경력구분 값 변경 이벤트
    const handleChange = (event) => {
        setExpVal(event.target.value);
    };

    //모집일 양식 변경 이벤트
    const handleDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'yyyy.MM.dd'); 
            setDateVal(formattedDate);
        } else {
            setDateVal(null);
        }
    }
    
    //컴포넌트 input값을 변수에 할당받는다. (단일값)
    const onChangeContent= (e) => {
        setContents({
            ...contents,
            [e.target.name]: e.target.value,
        });
    };

    //직무추가 버튼 이벤트
    const handleAddJobBtnClick = () => {
        setIsLendering(false);
        setInputCnt(prevCnt => prevCnt +1)

        // InputList 고윳값 -- 2025 09 10 아래 추가
        // 수정일 때
        // setInputCnt(prevCnt => prevCnt +1)


        // 신규일 때
        // InputList 고윳값  --2025 09 10
        // 숫자 => 알파벳
        const newAlphId = numberToAlphabet(nextNumId.current);
        setInputIdList(prevList => [
            ...prevList,
            {id: newAlphId}
        ]);

        console.log(newAlphId);
        nextNumId.current++;
    };

    //직무삭제 버튼 이벤트
    // const handleDelJobBtnClick = (value) => {
    const handleDelJobBtnClick = (idToDelete, jobToEdit) => {
        // console.log(idToDelete);
        if(mode === 'new') {
            setIsLendering(false);

            // InputList 고윳값 -- 2025 09 10 아래 변경
            setInputCnt(prevCount => (prevCount > 0 ? prevCount - 1 : 0));
            setInputIdList(prevList => prevList.filter(item => item.id !== idToDelete));
        }

        //mode가 edit일 경우 완전삭제할지 물어보고 삭제한다.
        else if(mode === 'edit') {
            const isDel = window.confirm("직무를 삭제하시겠습니까?");
            if(isDel) {
                delNotice(jobToEdit);
                setInputIdList(prevList => prevList.filter(item => item.id !== idToDelete));
            }
            else if(!isDel) {
                getDetailData();
                getMaxSeq();
                setDefaultData();
            }
        }

    }

    //입력완료 버튼 클릭 이벤트
    const handleSubmit = (value) => {
        setParamArrays(prevList => [...prevList, value]);
        console.log(paramArrays);

        // 처리되었어요!

        // 입력되지 않은 값이 있습니다.
    }


    //저장버튼 클릭 이벤트
    function save() {

        // 공통 파라미터 부분 입력여부 확인
        if(
           !contents.title || 
           !contents.dept || 
           !contents.area || 
           !expVal || 
           !dateVal 
             ) {
            alert('입력되지 않은 값이 있습니다.'); 
            return; 
        }

        // 입사지원서 입력여부 확인
        if(!uploadId ) {
            alert('입사지원서를 업로드해주세요.'); 
            return; 
        }
        
        //공통 파라미터
        const commonParams = {
            process : mode === 'new'? 'NEW' : 'EDIT',
            seq: mode === 'new'? maxSeq + 1 : cardkey,
            dept : contents.dept,
            area : contents.area,
            experience : expVal,
            noti_dt : dateVal,
            status : statVal,
            noti_title : contents.title,
            creator:'test', 
            createdt: createDt, 
            uploadid: uploadId
        }
        
        //직무별 파라미터
        let arrayParams = paramArrays.map(array => ({
            ...commonParams,
            childSeq : convertArrayToString(array.job),
            required: convertArrayToString(array.qualSh), 
            preferred: convertArrayToString(array.prefSh), 
            job: convertArrayToString(array.task), 
            employtype: convertArrayToString(array.jobType), 
            perNum: convertArrayToString(array.perNo),
            required_Detail: convertArrayToString(array.qualL), 
            preferred_Detail: convertArrayToString(array.prefL)        
        }))
        
        console.log(arrayParams);

        // 직무를 하나도 입력하지 않았을 때
        if(arrayParams.length < 1) {
            alert('입력되지 않은 값이 있습니다. '); 
            return;
        }
            
        // 빈 문자열이 있는데 저장버튼 눌렀으면 리턴시킴
        // if(mode === 'new') {
            // 모든 행을 순회하면서 하나라도 빈 필드가 있는지 검사
            const hasAnyEmptyRow = arrayParams.some(item => { // ✨ some() 메서드로 하나라도 조건에 맞는지 확인
                // 각 행(item)의 모든 value(값)를 순회 빈 값이 있는지 확인
                const isEmptyFieldInRow = Object.values(item).some(value => { 
                    // 값이 문자열이고, 그 값이 빈 문자열인지 검사
                    return typeof value === 'string' && value.trim() === '';
                });
                console.log(isEmptyFieldInRow);
                return isEmptyFieldInRow; 
            });

            console.log(hasAnyEmptyRow);

            if (hasAnyEmptyRow || hasAnyEmptyRow.length < 1) {
                alert('입력되지 않은 값이 있습니다. '); 
                return; 
            }
        // }
        
        //// 빈 문자열이 하나라도 있는 행을 삭제하는 로직  //입력완료 버튼으로 반복생성된 찌꺼기 데이터 삭제
        if(mode === 'new')
        {
            let filteredArrayParams = (['']);
            filteredArrayParams = arrayParams.filter(item => {
                const hasEmptyField = Object.values(item).some(value => {
                    return typeof value === 'string' && value === '';
                });
                return !hasEmptyField;
            });


            // ✨ 여기부터가 변경된 추가 로직이야! (seq, chidSeq 중복 제거 - '마지막' 항목만 남기기)
            const lastSeenItems = {}; // key: seq_chidSeq 조합, value: 해당 조합의 마지막 아이템 저장할 객체

            // filteredArrayParams 배열을 순회하면서 객체에 저장해.
            // 똑같은 combinationKey가 나오면 덮어쓰기 되니까,
            // 배열 끝까지 돌고 나면 '마지막'에 등장한 아이템만 남게 돼!
            filteredArrayParams.forEach(item => {
                const combinationKey = `${item.seq}_${item.childSeq}`;
                lastSeenItems[combinationKey] = item; // 여기서 계속 덮어쓰는 게 포인트!
            });

            // 객체에 남아있는 '값'들만 뽑아서 다시 배열로 만들어주면 끝!
            filteredArrayParams = Object.values(lastSeenItems);
            // ✨ 변경 로직 끝!
            arrayParams = filteredArrayParams;
        }

        console.log(commonParams)
        console.log(paramArrays)
        console.log(arrayParams);

        //Body로 넘기는 방식
        axios.post('/api/AdminSaveRecruit',arrayParams)
            .then(response => {
                console.log('성공적으로 데이터를 전송했어요', response.data);
            })
            .catch(error => {
                console.error('데이터 전송 중 오류가 발생했어요.', error);
            })

        //파라미터 하나씩 넘기는 방식
        // arrayParams.map(array => {
        //     axios.post('/api/AdminSaveRecruit',null,{params:{
        //         process: mode === 'new'? 'NEW' : 'EDIT',
        //         seq: mode === 'new'? maxSeq + 1 : cardkey,
        //         childSeq: array.job,
        //         required: array.qualSh, 
        //         preferred: array.prefSh, 
        //         dept: dept,
        //         job: array.task, 
        //         area: area,
        //         experience: exp,
        //         employtype: array.jobType, 
        //         noti_dt: dt,
        //         status: status, 
        //         noti_title: title, 
        //         creator:'test', 
        //         createdt: createDt, 
        //         uploadid: uploadId, 
        //         // uploadid: uploadId[0], 
        //         perNum: array.perNo,
        //         required_Detail: array.qualL, 
        //         preferred_Detail: array.prefL}})
        //         .catch(error => console.log(error))
        // })
        alert('저장되었습니다.')
        navigate('/RecruitmentCard');

        }

        
    //배열을 문자로 변환하는 함수
    const convertArrayToString = (value) => {
        if(Array.isArray(value)) {
            return value.join('');
        }
        return value;
    };



    //파일 업로드 이벤트 (바인딩)
    const handleFileChange = async (event) => {
        const selectedFiles = Array.from(event.target.files);
        const newFiles = [...files, ...selectedFiles];
        setFiles(newFiles);
        console.log(files)
        console.log(newFiles)

        const formData = new FormData();
        for (const file of newFiles) {  
            try {
                formData.append("multipartFiles", file);

            } catch (error) {
                // 파일 업로드 실패 시 에러 처리

            }
        }
        const uploadid = null;

        //수정 일때 => db에서 데이터를 들고올 경우
        if(mode === 'edit')
        {
        formData.append("uploadId", uploadId);
        setuploadId(uploadId); 

        //DB에 파일 저장
        await axios.post('/AddFilestemp', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        }).then((res) => { 
            setuploadId(res.data); 
        })
        .catch((err) => {console.error(err)}); 
        }
        else //새글 일때 
        {
        formData.append("uploadId", '');

        //DB에 파일 저장
        await axios.post('/uploadFilestemp2', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        }).then((res) => { 

            setuploadId(res.data); 
        })
        .catch((err) => {console.error(err)}); 
        }

    setFiles(newFiles);

    };

    //파일 삭제 이벤트
    let handleFileRemove = async (fileToRemove, index) => {

        let resultDt = null;

        axios.get('/api/FileListSelect',{params:{uploadkey:uploadId}})
        .then(response => {
        resultDt =   response.data;
        const formData = new FormData();

        const newFileId = String(resultDt[index].Fileid);
        formData.append("FileID", newFileId)

        //파일ID로 삭제
        axios.post('/DelFileList', formData,
            {headers:{
                'Content-Type': 'multipart/form-data'
            }}
            ).then((res) => { 

            })
            .catch((err) => {
            console.error("파일 삭제 오류", err);
            });

        }
    )
    .catch(error => console.error("DB 가져오기 오류", error));

        //UI에 삭제된 파일 안보이도록 파일 업데이트
        setFiles(prevFiles => prevFiles.filter(file => file !== files[index]));
};


    return (
        <>
        <div className='Top-root'>
            <div className='recruit-root'>
                <div className='recruit-container'>
                    <div className='header-container'>
                        <Text variant="titlename" className="header-text">{mode === 'edit'? '채용공고 수정' : '채용공고 등록'}</Text>
                        <div className='header-line'></div>
                    </div>
                    <div className="toggle-wrapper">
                            <Text variant="px20w600" className='toggle-text'>{isOn ? '모집중' : '모집완료'}</Text>
                            <div className={`toggle-container ${isOn ? 'on' : 'off'}`} onClick={toggle}>
                                <div className="toggle-circle" />
                            </div>
                    </div>
                    {/* part 1 경력구분~공고제목*/}
                    <div className='title-wrapper'>
                        <select className='selExp' value={expVal} onChange={handleChange}>
                            <option value={null}>--경력구분--</option>
                            <option value="01">경력·신입</option>
                            <option value="02">경력</option>
                            <option value="03">신입</option>
                        </select>
                        <Text variant="px20w600">공고 제목</Text>
                        <input 
                        name='title'
                        value={contents.title}
                        onChange={onChangeContent}
                        type='text'
                        style={{width: '600px', marginLeft: '10px', flex: '1'}}></input>
                    </div>
                    {/* ----------------------------------------------------------------------- */}
                    {/* part 2 모집 부서~근무지역 */}
                    <div className='basic-wrapper'>
                        <div className='date-wrapper'>
                            <Text  variant="px20w600">모집일 </Text>
                            <DatePicker
                                selected={dateVal ? new Date(dateVal) : null} 
                                onChange={handleDateChange}
                                dateFormat="yyyy-MM-dd"
                                onFocus={() => {
                                    setIsDateInputClicked(true);
                                }}
                                onBlur={() => {
                                    setIsDateInputClicked(false);
                                }}
                                placeholderText={isDateInputClicked === true ? "" : "클릭해서 날짜 선택"}
                            />
                        </div>

                        <div className='dept-wrapper'>
                            <Text variant="px20w600">모집 부서</Text>
                            <input 
                            name='dept'
                            value={contents.dept}
                            onChange={onChangeContent}
                            type='text'
                            style={{width: '150px', marginLeft: '10px', flex: '1'}}
                            onFocus={() => {
                                setIsDeptInputClicked(true);
                            }}
                            onBlur={() => {
                                setIsDeptInputClicked(false);
                            }}
                            placeholder={isDeptInputClicked === true ? "" : "팀, 그룹을 입력"}>
                            </input>
                        </div>

                        <div className='area-wrapper'>
                            <Text variant="px20w600">근무지역</Text>
                            <input 
                            name='area'
                            value={contents.area}
                            onChange={onChangeContent}
                            type='text'
                            style={{width: '100px', marginLeft: '10px'}}>
                            </input>
                        </div>
                    </div>
                    {/* ----------------------------------------------------------------------- */}
                    {/* part 3 input part */}
                    <p className='line'/>
                    {mode && mode === 'new' && (
                        <div>
                            <p className='line'/>
                            {/* {Array.from({length: inputCnt}, (_, index) => (
                                <div>
                                    <RecruitInputs key={index} addJobBtnClick={handleAddJobBtnClick}  delJobBtnClick={handleDelJobBtnClick} onSubmit={handleSubmit}
                                    mode={mode} eJob={job[index-1]}></RecruitInputs>
                                    <p className='line'/>
                                </div>
                            ))} */}
                            {/* //InputList 고윳값  -- 2025 09 10 추가 */}
                            {inputIdList.map((item) => (
                                <div key={item.id}>
                                    <RecruitInputs
                                        id={item.id}
                                        addJobBtnClick={handleAddJobBtnClick}
                                        delJobBtnClick={handleDelJobBtnClick}
                                        onSubmit={handleSubmit}
                                        mode={mode}
                                        // eJob={job[index-1]}
                                        >

                                    </RecruitInputs>

                                </div>
                            ))}
                        </div>
                    )}
                    {mode && mode === 'edit' && (
                        <div>
                            {Array.from({length: inputCnt}, (_, index) => (
                                <div>
                                    <RecruitInputs key={index} addJobBtnClick={handleAddJobBtnClick}  delJobBtnClick={handleDelJobBtnClick} onSubmit={handleSubmit}
                                    mode={mode} eJob={job[index]} ePerNo={perNo[index]} eType={type[index]} eTask={task[index]} eReqShort={reqShort[index]}
                                    eReqLong={reqLong[index]} ePrefShort={prefShort[index]} ePrefLong={prefLong[index]}></RecruitInputs>
                                    <p className='line'/>
                                </div>
                                
                            ))}
                        </div>
                    )}

                    {/* ----------------------------------------------------------------------- */}
                    {/* part 9 입사지원서 첨부 */} 
                    <div className='file-wrapper'>
                    <Text variant="px20w600" >입사지원서 첨부</Text>

                            <div style={{ marginTop: '20px', padding: '20px', border: '1px solid #ccc', borderRadius: '8px', width: '999px', margin: '0 auto' }}>
                            {/* <h2>첨부파일</h2> */}
                            <input type="file" id="inputtag"  onChange={handleFileChange} style={{ display: 'none' }}   multiple />
                            <label for="inputtag" style={{padding: '8px 16px',
                                      background: '#828282',
                                      color: '#fff',
                                      border: 'none',
                                      borderRadius: '4px',
                                      cursor: 'pointer',}}  > 파일 업로드</label>
                            <ul style={{ marginTop: '10px', padding: '0', listStyle:'', maxHeight: '200px', overflow: 'auto' , display:'Block'}}>
                              {files.map((file, index) => (
                                <li
                                  key={index}
                                  style={{
                                    
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '5px',
                                    padding: '5px 10px',
                                    borderBottom: '1px solid #ddd',
                                  }}
                                >
                                  {file.name}
                                  {/* {mode !== 'edit' &&  */}
                                    <button
                                    onClick={() => handleFileRemove(file, index)}
                                    style={{
                                      marginLeft: '10px',
                                      padding: '4px 8px',
                                      background: '#828282',
                                      color: '#fff',
                                      border: 'none',
                                      borderRadius: '4px',
                                      cursor: 'pointer',
                                    }}
                                  >
                                    삭제
                                  </button>
                      
                                </li>
                              ))}
                            </ul>
                          </div>
                    </div>
                    {/* part 10 저장버튼 및 footer */}

                    <div className='footer-wrapper'>
                        <Text variant="px18R">저장버튼 클릭 전, 모든 직무에 대한 '입력완료' 버튼을 클릭해주세요.</Text>
                        <button className='btnAllSave' onClick={save}>
                            <Text variant="px20" >저장</Text>
                        </button>
                    </div>
                </div>

            </div>
        </div>
        </>  
    );
};

export default Recruit;

